module.exports = __webpack_public_path__ + "static/media/kachexiao1.f3efd3a1.png";